import {
  client,
  getServiceHeaders,
  getServiceUrl,
  getAccessToken,
  ResponseCallback
} from '.'

/**
 *
 * @param path path to endpoint (e.g. /users/)
 * @param reqAuth boolean if request requires authentication
 * @param body Body of type I (can be any input)
 * @returns promise ServiceResponse <R>
 */
export const remove = async <I, O>({
  path,
  id,
  options,
  token = getAccessToken(),
  headers,
  respCb
}: {
  path: string
  id: I
  options?: { [k: string]: string | number }
  token?: string
  headers?: HeadersInit,
  respCb?: ResponseCallback<O>
}): Promise<O> => {
  return client<I,O>({
    url: getServiceUrl(`${path}${id ? '/' + id : ''}`, options),
    method: 'DELETE',
    headers: getServiceHeaders(token, headers),
    respCb
})
}
